<template lang="pug">
.v-compare-small.compare-small(:class="{'basket-small--empty': compareEmpty}")
	a.basket-small__widget(:href="compareEmpty ? null : compare.link")
		.basket-small__cell-icon
			v-svg-icon.basket-small__icon(icon="compare")
			.basket-small__badge.badge.badge--primary(v-if="compareCount") {{compareCount}}
		.basket-small__cell-main
			.basket-small__title.flc Сравнение
			.basket-small__price.flc(v-if="compareEmpty") Нет товаров
</template>

<script>
export default {
	computed: {
		compare() {
			return this.$store.state.compare;
		},

		compareEmpty() {
			return this.$store.getters['compare/compareEmpty'];
		},

		compareCount() {
			return this.$store.getters['compare/compareCount'];
		}
	}
};
</script>